export const menu = [
  { title: "EBay tools", link: "/ebay" },
  { title: "Multichannel", link: "/multichannel" },
  { title: "Pricing", link: "/pricing" },
  { title: "Help Center", link: "/help" },
  { title: "Blog", link: "/blog" },
];

export const socials = {
  instagram: "#",
  facebook: "#",
  linkedin: "#",
  twitter: "#",
};
